<template>
    <div class="vacancies-results">
        <z-card
            v-for="(item, index) in data"
            :key="index"
            theme="vacancy"
            class="js-content--sticky"
            :href="item.detailPageUrl"
            :is-background-image="false"
            :content-data="{
                title: item.name,
                tags: tags[index],
                schedule: item.schedule.value,
                location: item.location.value
            }"
            is-shift-tag
            :is-fire-tag="item.hot.value === 'Y'"
        >
        </z-card>
    </div>
</template>
<script setup>
import ZCard from "@/components/ZCard/"
const props = defineProps({
    data: {
        type: Array
    }
})

let tags = [];
props.data.forEach((item, index) => {
    let tmp = [];
    if (Array.isArray(item.type.value)) { tmp = item.type.value; } else { tmp.push(item.type.value); }
    if (item.education.value === 'Y') { tmp.push('Возможно обучение'); }
    tags[index] = tmp;
});


</script>

<style lang="scss">
.vacancies-results{
    & .z-card{
        &:not(:last-of-type){
            @include margin-level(bottom, S);
        }
    }
}
</style>
